import ApiService from "@/common/api.service";

const PATH = "stock/purchase-orders";

export const GET_STOCK_PURCHASE_ORDERS = "getStockPurchaseOrders";
export const GET_STOCK_PURCHASE_ORDER = "getStockPurchaseOrder";
export const CREATE_STOCK_PURCHASE_ORDER = "createStockPurchaseOrder";
export const UPDATE_STOCK_PURCHASE_ORDER = "updateStockPurchaseOrder";
export const CONFIRM_STOCK_PURCHASE_ORDER = "confirmStockPurchaseOrder";
export const CANCEL_STOCK_PURCHASE_ORDER = "cancelStockPurchaseOrder";
export const CREATE_RECEIPT_FROM_PO = "createReceiptFromPurchaseOrder";
export const RECORD_PO_IN_TRANSIT = "recordPurchaseOrderInTransit";
export const GET_STOCK_PO_MOVEMENTS = "getStockPurchaseOrderMovements";
export const UPLOAD_STOCK_PO_FILES = "uploadStockPurchaseOrderFiles";
export const DELETE_STOCK_PO_FILE = "deleteStockPurchaseOrderFile";
export const DOWNLOAD_STOCK_PO_FILE = "downloadStockPurchaseOrderFile";
export const REGENERATE_STOCK_PO_DOCUMENT = "regenerateStockPurchaseOrderDocument";
export const CREATE_TRANSPORT_ORDER_FROM_PO = "createTransportOrderFromPurchaseOrder";
export const GET_STOCK_PO_COUNTERPARTY_SO_OPTIONS = "getStockPurchaseOrderCounterpartySalesOrderOptions";

const actions = {
  [GET_STOCK_PO_COUNTERPARTY_SO_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/counterparty-sales-order-options`, params || {})
        .then(({ data }) => resolve(data.data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PURCHASE_ORDERS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PURCHASE_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_PURCHASE_ORDER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_PURCHASE_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONFIRM_STOCK_PURCHASE_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/confirm`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_PURCHASE_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RECORD_PO_IN_TRANSIT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/record-in-transit`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_RECEIPT_FROM_PO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/create-receipt`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PO_MOVEMENTS](context, payload) {
    const purchaseOrderId = payload.purchaseOrderId || payload.id;

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${purchaseOrderId}/movements`, {
        itemsPerPage: payload.itemsPerPage || 50,
        page: payload.page || 1,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_PO_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_PO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_PO_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_PO_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_TRANSPORT_ORDER_FROM_PO](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/create-transport-order`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
